import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from '../../Common/commonStyles';

const styles = StyleSheet.create({
  elements: {
    ...commonStyles.fontM,
    marginHorizontal: commonStyles.marginHorizontal,
    paddingBottom: '2%',
    borderBottom: '1.5px solid #b8b8b8',
    marginBottom: '2%',
  },
  titleRow: {
    ...commonStyles.flexRow,
    marginBottom: '2%',
  },
  title: {
    fontWeight: 'bold',
  },
  mainColumn: {
    width: '30%',
  },
  sizeColumn: {
    flex: 1,
  },
  sizeRow: {
    ...commonStyles.flexRow,
    marginBottom: '1%',
  },
  sizeCell: {},
});

function VariantsPage({ variants, sizes, t }) {
  const rowSummaries = variants.map((variant) => ({
    name: variant.name,
    id: `${variant.id}_summary`,
    quantity: sizes.reduce((sum, size) => {
      const variantQuantity = variant.quantities.find(
        (q) => q?.isActive && q?.size?.id === size.id,
      );
      return sum + (variantQuantity ? variantQuantity.quantity : 0);
    }, 0),
  }));

  const columnSummaries = sizes
    .filter((s) => s.isActive)
    .map((size) => ({
      name: size.name,
      id: `${size.id}_summary`,
      quantity: variants.reduce((sum, v) => {
        const variantQuantity = v.quantities.find((q) => q?.isActive && q?.size?.id === size.id);
        return sum + (variantQuantity ? variantQuantity.quantity : 0);
      }, 0),
    }));

  return (
    <View style={styles.elements}>
      <View style={styles.titleRow}>
        <View style={styles.mainColumn}>
          <Text style={styles.title}>{t('model_variants_pieces')}</Text>
        </View>
        {sizes
          .filter((s) => s.isActive)
          .map((size) => (
            <View key={size.id} style={styles.sizeColumn}>
              <Text>{size.name}</Text>
            </View>
          ))}
        {/* Summary column header */}
        <View style={styles.sizeColumn}>
          <Text>{t('common:summary')}</Text>
        </View>
      </View>
      {variants.map((variant, index) => (
        <View key={variant.id} style={styles.sizeRow}>
          <View style={styles.mainColumn}>
            <Text>{variant.name}</Text>
          </View>
          {variant?.quantities?.map(
            (variantQuantity, qIdx) =>
              variantQuantity &&
              sizes.find((size) => size.id === variantQuantity.size?.id)?.isActive && (
                <View key={variantQuantity.id ?? qIdx} style={styles.sizeColumn}>
                  <Text style={styles.sizeCell}>{variantQuantity.quantity}</Text>
                </View>
              ),
          )}
          {/* Row summary column */}
          <View style={styles.sizeColumn}>
            <Text style={styles.sizeCell}>{rowSummaries.map((row) => row.quantity)[index]}</Text>
          </View>
        </View>
      ))}
      {/* Summary row */}
      <View style={styles.sizeRow}>
        <View style={styles.mainColumn}>
          <Text>{t('common:summary')}</Text>
        </View>
        {columnSummaries.map((columnSummary) => (
          <View key={columnSummary.id} style={styles.sizeColumn}>
            <Text style={styles.sizeCell}>{columnSummary.quantity}</Text>
          </View>
        ))}
        {/* Total of totals */}
        <View style={styles.sizeColumn}>
          <Text style={styles.sizeCell}>
            {columnSummaries.reduce((sum, col) => sum + col.quantity, 0)}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default withTranslation('specification')(memo(VariantsPage));
